package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableState
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.document
import kotlinx.browser.window
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Option
import org.jetbrains.compose.web.dom.Select
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.HTMLElement

@Composable
fun DropDownItem(
    modifier: Modifier = Modifier,
    options: List<dynamic>,
    height: CSSSizeValue<CSSUnit.px> = Dimen.outlinedEditTextParentHeight,
    label: String,
    fillMaxWidth: Boolean = false,
    disable: Boolean = false,
    selectedItem: dynamic,
    onOptionClick: (dynamic) -> Unit,
    itemWidth: CSSSizeValue<CSSUnit.px> = Dimen.mediumEditTextWidth,
    borderRadius: CSSSizeValue<CSSUnit.px> = Dimen.lowBorderRadius,
    content: @Composable (dynamic) -> Unit,
    iconPath: String?=null,
    id: String?=null,
    isFixed: Boolean=false,
    clearAvailable: Boolean = false,
    onClearClick: (dynamic) -> Unit = {}
) {
    val isHovered = remember { mutableStateOf(false) }
    val isExpanded = remember { mutableStateOf(false) }
    val isFocused= remember { mutableStateOf(false) }
    val isDisabled = disable || options.isEmpty()
    val labelMargin = Dimen.mediumPadding
    val dropdownMenuCoords = remember { mutableStateOf<Pair<Float, Float>?>(null) }

    LaunchedEffect(isExpanded.value) {
        isFocused.value = isExpanded.value
    }

    if (isExpanded.value){
        Box(
            modifier = Modifier
                .position(Position.Absolute)
                .top(0.px)
                .left(0.px)
                .right(0.px)
                .bottom(0.px)
                .fillMaxSize()
                .onClick {
                    isExpanded.value=false
                }
        )
    }


    Box(
        modifier = modifier
            .onFocusOut{
                isFocused.value=false
            }
            .onFocusIn{
                isFocused.value=true
            }
            .onMouseOver { if (!isDisabled) isHovered.value = true }
            .onMouseLeave { if (!isDisabled) isHovered.value = false }
            .height(height)
            .thenIf(fillMaxWidth) { Modifier.fillMaxWidth() }
    ) {
        SpanText(
            text = label,
            modifier = Modifier
                .align(Alignment.TopStart)
                .margin(left = Dimen.mediumPadding)
                .zIndex(Constants.ZIndex.smallZIndex)
                .padding(leftRight = Dimen.smallPadding)
                .backgroundColor(Theme.White.rgb)
                .fontWeight(FontWeight.Normal)
                .color(if (isDisabled) Theme.TextDisabled.rgb
                else if (isFocused.value) Theme.PrimaryMain.rgb else
                    Theme.TextSecondary.rgb)
                .fontFamily(FontFamily.Jakarta)
                .fontSize(FontSizes.semiMediumFontSize)
        )

        Box(
            modifier = Modifier
                .display(DisplayStyle.Flex)
                .align(Alignment.BottomStart)
                .flexDirection(FlexDirection.Column)
                .width(itemWidth)
                .thenIf(fillMaxWidth) {
                    Modifier.fillMaxWidth()
                }
                .height(Dimen.mediumOutlinedEditTextHeight)
                .fontFamily(FontFamily.Jakarta)
                .borderRadius(borderRadius)
                .backgroundColor(Theme.Transparent.rgb)
                .position(Position.Relative)
        ) {
            if (iconPath!=null) {
                VectorIcon(
                    modifier=Modifier
                        .position(Position.Absolute)
                        .zIndex(Constants.ZIndex.mediumZIndex)
                        .left(Dimen.mediumPadding)
                        .top(55.percent)
                        .styleModifier {
                            property("transform", "translateY(-50%)")
                            property("pointer-events", "none")
                        },
                    pathData = iconPath,
                    width = Dimen.mediumIconSize,
                    height=Dimen.mediumIconSize,
                    color = Theme.ActionActive.hex,
                )
            }

            VectorIcon(
                modifier = Modifier
                    .position(Position.Absolute)
                    .zIndex(Constants.ZIndex.mediumZIndex)
                    .right(Dimen.mediumPadding)
                    .top(50.percent)
                    .attrsModifier {
                        style {
                            property("transform-origin", "center center")
                            property("transform", if (isExpanded.value)
                                "translateY(-50%) rotate(180deg)"
                            else "translateY(-50%) rotate(0deg)")
                            property("pointer-events", "none")
                        }
                    },
                pathData = Res.PathIcon.arrowBelow,
                width = Dimen.mediumIconSize,
                height = Dimen.mediumIconSize,
                color = if (isDisabled) Theme.TextDisabled.hex
                else if (isFocused.value) Theme.PrimaryMain.hex
                else Theme.ActionActive.hex,
            )

            if (clearAvailable && !isExpanded.value && !isDisabled && (selectedItem != null)) {
                VectorIcon(
                    modifier = Modifier
                        .position(Position.Absolute)
                        .zIndex(Constants.ZIndex.mediumZIndex)
                        .right(Dimen.mediumPadding.times(2))
                        .top(60.percent)
                        .onClick {
                            onClearClick(null)

                            isExpanded.value = false
                            isFocused.value = false
                        }
                        .attrsModifier {
                            style {
                                property("transform", "translateY(-50%)")
                                property("cursor", "pointer")
                            }
                        },
                    pathData = Res.PathIcon.close,
                    width = Dimen.mediumIconSize,
                    height = Dimen.mediumIconSize,
                    color = Theme.ActionActive.hex,
                )
            }

            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(Dimen.mediumOutlinedEditTextHeight)
                    .id(id?:"")
                    .fontSize(FontSizes.mediumFontSize)
                    .onClick {
                        if (!isDisabled) {
                            isExpanded.value = !isExpanded.value
                            isFocused.value = !isFocused.value
                            if (isFixed) {
                                window.setTimeout({
                                    val el = document.getElementById(id?:"") as? HTMLElement
                                    if (el != null) {
                                        val rect = el.getBoundingClientRect()
                                        dropdownMenuCoords.value = Pair(rect.left.toFloat(), rect.bottom.toFloat())
                                    }
                                }, 10)
                            }
                        }
                    }
                    .styleModifier {
                        property("border-width", if (isFocused.value)
                            "${Dimen.mediumThickness.value}px"
                        else
                            "${Dimen.smallThickness.value}px")
                        property("border-style", "solid")
                        property("border-color", when {
                            options.isEmpty()->Theme.InputEnabledBorder.hex
                            isDisabled -> Theme.TextDisabled.hex
                            isFocused.value -> Theme.PrimaryMain.hex
                            isHovered.value -> Theme.TextPrimary.hex
                            else -> Theme.InputEnabledBorder.hex
                        })
                        property("border-radius", "$borderRadius")
                        property("background-color", Theme.White.hex)
                        property("box-sizing", "border-box")
                        property("font-family", FontFamily.Jakarta)
                        property("cursor",
                            if (isDisabled) "not-allowed" else "pointer")
                        property("display", "flex")
                        property("align-items", "center")
                        property("padding-left", if (iconPath != null)
                            "${Dimen.mediumPadding.value + Dimen.mediumIconSize}px"
                        else
                            "${labelMargin.value}px")
                        property("padding-right",
                            "${Dimen.largePadding.value +
                                    Dimen.mediumIconSize}px")
                    }
            ) {
                if (selectedItem != null) {
                    Box(
                        modifier = Modifier
                            .styleModifier {
                                property("position", "absolute")
                                property("left", if (iconPath != null)
                                    "${Dimen.mediumPadding.value + Dimen.mediumIconSize}px"
                                else
                                    "${labelMargin.value}px")
                                property("top", "50%")
                                property("transform", "translateY(-50%)")
                            }
                    ) {
                        content(selectedItem)
                    }
                }
            }

            if (isExpanded.value && !isDisabled && (!isFixed
                        || dropdownMenuCoords.value != null)) {
                Box(
                    modifier = Modifier
                        .padding(topBottom = Dimen.normalPadding)
                        .zIndex(Constants.ZIndex.extraLargeZIndex)
                        .top(Dimen.mediumOutlinedEditTextHeight
                            .plus(Dimen.normalPadding))
                        .width(if (fillMaxWidth) 100.percent else itemWidth)
                        .styleModifier {
                            if (isFixed) {
                                val coords = dropdownMenuCoords.value!!
                                property("position", "fixed")
                                property("left", "${coords.first}px")
                                property("top", "${coords.second}px")
                            } else {
                                property("position", "absolute")
                            }
                            property("background-color", Theme.White.hex)
                            property("border-radius", "${Dimen.semiLargeRadius}")
                            property("box-shadow", "0px 3px 15px 0px" +
                                    " ${Theme.ActionFocused.rgb}")
                            property("max-height", "250px")
                            property("overflow-y", "auto")
                            property("overflow-x", "hidden")
                            property("border", "1px solid ${Theme.ActionFocused.hex}")
                            property("scrollbar-width", "thin")
                            property("scrollbar-color",
                                "${Theme.TextSecondary.hex} transparent")
                        }
                ) {
                    Column(
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        options.forEachIndexed { index, option ->
                            val isSelected = option == selectedItem
                            val itemHoveredState = remember { mutableStateOf(false) }
                            Div(
                                attrs = {
                                    style {
                                        property("display", "flex")
                                        property("align-items", "center")
                                        property("width", "100%")
                                        property("height",
                                            "${Dimen.mediumOutlinedEditTextHeight.value}px")
                                        property("padding-left",
                                            "${labelMargin.value}px")
                                        property("padding-right",
                                            "${Dimen.mediumPadding.value}px")
                                        property("background-color", when {
                                            isSelected -> Theme.PrimaryStatesSelected.hex
                                            itemHoveredState.value -> Theme.PrimaryStatesHover.hex
                                            else -> Theme.White.hex
                                        })
                                        property("cursor", "pointer")
                                        property("user-select", "none")
                                    }

                                    onMouseOver { itemHoveredState.value = true }
                                    onMouseOut { itemHoveredState.value = false }
                                    onClick { event ->
                                        event.stopPropagation()
                                        onOptionClick(option as Any)
                                        isExpanded.value = false
                                        isFocused.value = false
                                    }
                                }
                            ) {
                                content(option)
                            }

//                            if (index < options.size - 1) {
//                                Separator()
//                            }
                        }
                    }
                }
            }

            Select(
                attrs = {
                    if (isDisabled) {
                        attr("disabled", "disabled")
                    }
                    style {
                        property("position", "absolute")
                        property("opacity", "0")
                        property("width", "0")
                        property("height", "0")
                        property("pointer-events", "none")
                    }
                    // Keep selected value in sync
                    if (selectedItem != null) {
                        attr("value", selectedItem.toString())
                    }
                }
            ) {
                options.forEach { option ->
                    Option(
                        attrs = {
                            if (option == selectedItem) attr("selected", "selected")
                        },
                        value = option
                    ) {
                        SpanText(
                            text = option.toString(),
                            modifier = Modifier
                                .fontSize(FontSizes.mediumFontSize)
                                .color(
                                    if (disable) Theme.TextDisabled.rgb
                                    else Theme.TextPrimary.rgb
                                )
                                .fontWeight(FontWeight.Normal)
                                .fontFamily(FontFamily.Jakarta)
                        )
                    }
                }
            }
        }
    }


}


@Composable
fun DropDownItem(
    modifier: Modifier = Modifier,
    options: List<dynamic>,
    height: CSSSizeValue<CSSUnit.px> = Dimen.outlinedEditTextParentHeight,
    label: String,
    fillMaxWidth: Boolean = false,
    disable: Boolean = false,
    selectedItem: dynamic,
    onOptionClick: (dynamic) -> Unit,
    itemWidth: CSSSizeValue<CSSUnit.px> = Dimen.mediumEditTextWidth,
    borderRadius: CSSSizeValue<CSSUnit.px> = Dimen.lowBorderRadius,
    displayText: (dynamic) -> String,
    iconPath: String?=null,
    clearAvailable: Boolean = false,
    onClearClick: (dynamic) -> Unit = {}
) {
    DropDownItem(
        modifier = modifier,
        options = options,
        height = height,
        label = label,
        fillMaxWidth = fillMaxWidth,
        disable = disable,
        selectedItem = selectedItem,
        onOptionClick = onOptionClick,
        itemWidth = itemWidth,
        borderRadius = borderRadius,
        iconPath = iconPath,
        content = { item ->
            SpanText(
                text = displayText(item),
                modifier = Modifier
                    .fontSize(FontSizes.mediumFontSize)
                    .color(
                        if (disable) Theme.TextDisabled.rgb
                            else Theme.TextPrimary.rgb
                    )
                    .fontWeight(FontWeight.Normal)
                    .fontFamily(FontFamily.Jakarta)
            )
        },
        clearAvailable = clearAvailable,
        onClearClick = onClearClick
    )
}

@Composable
fun CustomDropDown(
    modifier: Modifier = Modifier,
    height: CSSSizeValue<CSSUnit.px> = Dimen.outlinedEditTextParentHeight,
    label: String,
    fillMaxWidth: Boolean = false,
    disable: Boolean = false,
    paddingTopBottom:CSSSizeValue<CSSUnit.px> = Dimen.normalPadding,
    fontWeight: FontWeight = FontWeight.Normal,
    itemWidth: CSSSizeValue<CSSUnit.px> = Dimen.mediumEditTextWidth,
    borderRadius: CSSSizeValue<CSSUnit.px> = Dimen.lowBorderRadius,
    selectedDisplayContent: @Composable () -> Unit = {},
    iconPath: String? = null,
    id: String? = null,
    isFixed: Boolean = false,
    dropdownContent: @Composable (isExpanded:MutableState<Boolean>) -> Unit
) {
    val isHovered = remember { mutableStateOf(false) }
    val isExpanded = remember { mutableStateOf(false) }
    val isFocused = remember { mutableStateOf(false) }
    val labelMargin = Dimen.mediumPadding
    val dropdownMenuCoords = remember { mutableStateOf<Pair<Float, Float>?>(null) }

    LaunchedEffect(isExpanded.value) {
        isFocused.value = isExpanded.value
    }

    if (isExpanded.value) {
        Box(
            modifier = Modifier
                .position(Position.Absolute)
                .top(0.px)
                .left(0.px)
                .right(0.px)
                .bottom(0.px)
                .fillMaxSize()
                .onClick {
                    isExpanded.value = false
                }
        )
    }

    Box(
        modifier = modifier
            .onFocusOut {
                isFocused.value = false
            }
            .onFocusIn {
                isFocused.value = true
            }
            .onMouseOver { if (!disable) isHovered.value = true }
            .onMouseLeave { if (!disable) isHovered.value = false }
            .height(height)
            .thenIf(fillMaxWidth) { Modifier.fillMaxWidth() }
    ) {
        // Label
        SpanText(
            text = label,
            modifier = Modifier
                .align(Alignment.TopStart)
                .margin(left = Dimen.mediumPadding)
                .zIndex(Constants.ZIndex.smallZIndex)
                .padding(leftRight = Dimen.smallPadding)
                .backgroundColor(Theme.White.rgb)
                .fontWeight(FontWeight.Normal)
                .color(if (disable) Theme.TextDisabled.rgb
                else if (isFocused.value) Theme.PrimaryMain.rgb else
                    Theme.TextSecondary.rgb)
                .fontFamily(FontFamily.Jakarta)
                .fontSize(FontSizes.semiMediumFontSize)
        )
        Box(
            modifier = Modifier
                .display(DisplayStyle.Flex)
                .align(Alignment.BottomStart)
                .flexDirection(FlexDirection.Column)
                .width(itemWidth)
                .thenIf(fillMaxWidth) {
                    Modifier.fillMaxWidth()
                }
                .height(Dimen.mediumOutlinedEditTextHeight)
                .fontFamily(FontFamily.Jakarta)
                .borderRadius(borderRadius)
                .backgroundColor(Theme.Transparent.rgb)
                .position(Position.Relative)
        ) {
            // Optional custom icon
            if (iconPath != null) {
                VectorIcon(
                    modifier = Modifier
                        .position(Position.Absolute)
                        .zIndex(Constants.ZIndex.mediumZIndex)
                        .left(Dimen.mediumPadding)
                        .top(55.percent)
                        .styleModifier {
                            property("transform", "translateY(-50%)")
                            property("pointer-events", "none")
                        },
                    pathData = iconPath,
                    width = Dimen.mediumIconSize,
                    height = Dimen.mediumIconSize,
                    color = Theme.ActionActive.hex,
                )
            }

            // Dropdown arrow
            VectorIcon(
                modifier = Modifier
                    .position(Position.Absolute)
                    .zIndex(Constants.ZIndex.mediumZIndex)
                    .right(Dimen.mediumPadding)
                    .top(50.percent)
                    .attrsModifier {
                        style {
                            property("transform-origin", "center center")
                            property("transform", if (isExpanded.value)
                                "translateY(-50%) rotate(180deg)"
                            else "translateY(-50%) rotate(0deg)")
                            property("pointer-events", "none")
                        }
                    },
                pathData = Res.PathIcon.arrowBelow,
                width = Dimen.mediumIconSize,
                height = Dimen.mediumIconSize,
                color = if (disable) Theme.TextDisabled.hex
                else if (isFocused.value) Theme.PrimaryMain.hex
                else Theme.ActionActive.hex,
            )

            // Main clickable box
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(Dimen.mediumOutlinedEditTextHeight)
                    .id(id ?: "")
                    .fontSize(FontSizes.mediumFontSize)
                    .onClick {
                        if (!disable) {
                            isExpanded.value = !isExpanded.value
                            isFocused.value = !isFocused.value
                            if (isFixed) {
                                window.setTimeout({
                                    val el = document.getElementById(id ?: "") as? HTMLElement
                                    if (el != null) {
                                        val rect = el.getBoundingClientRect()
                                        dropdownMenuCoords.value = Pair(rect.left.toFloat(), rect.bottom.toFloat())
                                    }
                                }, 10)
                            }
                        }
                    }
                    .styleModifier {
                        property("border-width", if (isFocused.value)
                            "${Dimen.mediumThickness.value}px"
                        else
                            "${Dimen.smallThickness.value}px")
                        property("border-style", "solid")
                        property("border-color", when {
                            disable -> Theme.TextDisabled.hex
                            isFocused.value -> Theme.PrimaryMain.hex
                            isHovered.value -> Theme.TextPrimary.hex
                            else -> Theme.InputEnabledBorder.hex
                        })
                        property("border-radius", "$borderRadius")
                        property("background-color", Theme.White.hex)
                        property("box-sizing", "border-box")
                        property("font-family", FontFamily.Jakarta)
                        property("font-weight", fontWeight.toString())
                        property("cursor",
                            if (disable) "not-allowed" else "pointer")
                        property("display", "flex")
                        property("align-items", "center")
                        property("padding-left", if (iconPath != null)
                            "${Dimen.mediumPadding.value + Dimen.mediumIconSize}px"
                        else
                            "${labelMargin.value}px")
                        property("padding-right",
                            "${Dimen.largePadding.value + Dimen.mediumIconSize}px")
                    }
            ) {
                selectedDisplayContent()
            }

            if (isExpanded.value && !disable && (!isFixed || dropdownMenuCoords.value != null)) {
                Box(
                    modifier = Modifier
                        .onClick {
                            isExpanded.value=false
                        }
                        .padding(topBottom =paddingTopBottom)
                        .zIndex(Constants.ZIndex.extraLargeZIndex)
                        .top(Dimen.mediumOutlinedEditTextHeight.plus(Dimen.normalPadding))
                        .width(if (fillMaxWidth) 100.percent else itemWidth)
                        .styleModifier {
                            if (isFixed) {
                                val coords = dropdownMenuCoords.value!!
                                property("position", "fixed")
                                property("left", "${coords.first}px")
                                property("top", "${coords.second}px")
                            } else {
                                property("position", "absolute")
                            }
                            property("background-color", Theme.White.hex)
                            property("border-radius", "${Dimen.semiLargeRadius}")
                            property("box-shadow", "0px 3px 15px 0px ${Theme.ActionFocused.rgb}")
                              property("overflow-y", "auto")
                            property("overflow-x", "hidden")
                            property("border", "1px solid ${Theme.ActionFocused.hex}")
                        }
                ) {
                    dropdownContent(isExpanded)
                }
            }
        }
    }
}